import { sleep } from "common/utils/sleep";

export const performPostAttachment = async (
  file: File,
  progressCallback?: (progress: number) => void
): Promise<void> => {
  progressCallback && progressCallback(1);
  await sleep(500);
  if (file.name === "Captura de Pantalla 2020-10-13 a la(s) 10.33.45.png")
    throw new Error("Error uploading file");
  progressCallback && progressCallback(25);
  await sleep(1000);
  progressCallback && progressCallback(40);
  await sleep(1000);
  progressCallback && progressCallback(80);
  await sleep(1500);
  progressCallback && progressCallback(100);
  return;
};
